import React from 'react';
import head from 'lodash/head';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Container, Row } from 'reactstrap';

import Stripe from '../../../components/Stripe';
import Summary from './Summary';
import { InjectInvoiceData } from '../../../components';
import { onLodgeBookingRequestSuccess } from '../../../redux/actions/analyticsEventActions';

type Props = {
  history: Object,
  invoiceId: string,
  match: {
    params: {
      invoiceId: string,
      lodgeId: string,
    },
  },
  location: {
    pathname: string,
  },
  trackBooking: () => void,
};

const mapDispatchToProps = dispatch => ({
  trackBooking: (revenue, name, address) =>
    dispatch(onLodgeBookingRequestSuccess(revenue, name, address)),
});

const Payment = (props: Props) => (
  <InjectInvoiceData>
    {({ lineItems, invoiceId, invoice: { amount, status, rate, discount } }) => {
      const { itemData: lodgeLineItem } = head(
        lineItems.filter(l => l.itemType === 'lodge')
      );

      return (
        <Container>
          <Row>
            {status.toLowerCase() === 'pending' && (
              <Stripe
                invoiceId={invoiceId}
                amount={amount}
                onSuccess={() => {
                  const { history, location, trackBooking } = props;
                  const {
                    lodge: { name, address },
                  } = lodgeLineItem;

                  try {
                    trackBooking(amount, name, address);
                  } catch (err) {
                    console.log(err);
                  }

                  history.push(`${location.pathname}/payment-success`);
                }}
              />
            )}
            <Summary
              lineItem={lodgeLineItem}
              amount={amount}
              rate={rate}
              discount={discount}
            />
          </Row>
        </Container>
      );
    }}
  </InjectInvoiceData>
);

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(Payment)
);



// WEBPACK FOOTER //
// ./src/screens/Lodge/Payment/Payment.js